<template>
  <div class="head_box">
    <div class="head_box_show" :class="this.tomi ? '' : 'head_box_background'">
      <el-row class="head_box_row">
        <el-col class="head_box_la" :span="12">
          <div class="grid-content bg-purple">
            <img
              class="head_box_logo"
              src="../../../assets/img/pc/logo.png"
              alt=""
            />
          </div>
        </el-col>
        <el-col class="head_box_r" :span="12">
          <div class="grid-content bg-purple-light">
            <el-button
              @click="drawer = !drawer"
              type="text"
              style="margin-left: 16px"
            >
              <div class="head_box_r_bu">
                <div class="head_box_r_heng"></div>
                <div class="head_box_r_heng"></div>
                <div class="head_box_r_heng"></div>
              </div>
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 下拉 -->
    <el-drawer
      class="head_navigation"
      :visible.sync="drawer"
      direction="ttb"
      :show-close="false"
      :close-on-press-escape="false"
    >
      <div
        class="head_navigation_div"
        @click="navigation(item.id)"
        v-for="(item, index) in form"
        :key="index"
      >
        {{ item.name }}
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
      tomi: true,
      oldScrollTop: 0,
      form: [
        {
          name: "ABOUT US",
          id: 4,
        },
        {
          name: "PRODUCT CONCEPT",
          id: 5,
        },
        {
          name: "CONTACT US",
          id: 8,
        },
        {
          name: "BRAND CONCEPT",
          id: 7,
        },
        {
          name: "CASE CENTENT",
          id: 6,
        },
      ],
    };
  },
  mounted() {
    window.addEventListener("scroll", this.scrolling);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrolling);
  },
  methods: {
    navigation(e) {
      this.$store.commit("app/loginShow", e);
      //   // document.documentElement.scrollTop= 1200;
      //   // document.documentElement.scrollTop(0,1200);
      //   // window.scrollTo({
      //   //   top: 160,
      //   //   behavior: "smooth",
      //   // });
      // } else if (e.name == "ABOUT US") {
      //   window.scrollTo({
      //     top: 1400,
      //     behavior: "smooth",
      //   });
      // }
      // window.scrollTo(0, 1200)
      this.drawer = false;
    },
    scrolling() {
      // 滚动条距文档顶部的距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 滚动条滚动的距离
      let scrollStep = scrollTop - this.oldScrollTop;
      // 更新——滚动前，滚动条距文档顶部的距离
      this.oldScrollTop = scrollTop;

      if (scrollTop > 100) {
        this.tomi = false;
      } else {
        this.tomi = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
// .head_box {

//   width: 100%;
//   height: 160px;
//   line-height: 160px;
//   min-width: 1200px;
//   opacity: 1;
// }
.head_box_show {
  width: 100%;
  height: 100px;
  line-height: 100px;
  min-width: 1200px;
  position: fixed;
  top: 0px;
  opacity: 0.6;
  z-index: 2050;
}
.head_box_background {
  background-color: rgba(#343434, 0.8);
}
.head_box_row {
  height: 100%;
}
.head_box_row2 {
  position: fixed;
  top: 0px;
  z-index: 2001;
  height: 100%;
  background: #ffffff;
  opacity: 0.6;
}
.head_box_la {
  height: 100%;
  padding-left: 120px;
}
.head_box_r {
  text-align: right;
  padding-right: 120px;
  height: 100%;
}
.head_box_logo {
  width: 150px;
  height: 48px;
  position: relative;
   top: 50%;
  transform: translateY(50%);
  // padding-top: 27px;
}
.head_box_r_bu {
   position: relative;
   top: 50%;
  transform: translateY(32%);
}
.head_box_r_heng {
  width: 40px;
  height: 4px;
  background: #ffffff;
  margin-top: 9px;
}
.head_navigation_div {
  text-align: center;
  font-size: 26px;
  font-family: Manrope3;
  font-weight: 400;
  color: #ffffff;
  line-height: initial;
  cursor: pointer;
  margin-top: 44px;
}
.head_navigation_div:hover {
  color: #919191;
}
</style>


// WEBPACK FOOTER //
// src/components/pc/head/index.vue